/**
 * Daily FX cache helper. Persists the latest fetched rates to localStorage
 * with a TTL. Pages mount CurrencyStrip / CurrencyProvider on every render,
 * so without this we'd hit the API on every page load. With this, the user
 * fetches once per 24h.
 *
 * Usage:
 *   const rates = await getDailyFX("/api/tools/fx", "fortune.fx.daily.tools");
 */
const TTL_MS = 24 * 60 * 60 * 1000; // 24h

export async function getDailyFX(url, storageKey) {
  if (typeof window === "undefined") return null;
  try {
    const cached = window.localStorage.getItem(storageKey);
    if (cached) {
      const parsed = JSON.parse(cached);
      if (parsed && parsed.ts && (Date.now() - parsed.ts) < TTL_MS && parsed.payload) {
        return parsed.payload;
      }
    }
  } catch {
    /* fall through to network */
  }
  // Cache miss or stale: fetch and persist.
  const res = await fetch(url, { credentials: "include" });
  if (!res.ok) throw new Error(`FX fetch ${res.status}`);
  const payload = await res.json();
  try {
    window.localStorage.setItem(storageKey, JSON.stringify({ ts: Date.now(), payload }));
  } catch {
    /* localStorage may be full or private mode */
  }
  return payload;
}
